import React from 'react';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusesSection } from './components/BonusesSection';
import { PurchaseSection } from './components/PurchaseSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-gray-800 bg-brand-cream selection:bg-brand-roseGold selection:text-white" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BenefitsSection data-id="element-4" />
        <BonusesSection data-id="element-5" />
        <PurchaseSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
      </main>

      <Footer data-id="element-8" />
    </div>;
}